module.exports = __webpack_public_path__ + "angle-arrow-down.0c5d1064d445aab29d0d3588301cbfb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/angle-arrow-down.svg
// module id = 146
// module chunks = 0